import { ref, watch } from "vue";
import findScrollableElements from "../utils/shared/findScrollableElements.js";
export default (anchorElement, dropdownElement, isOpen, positionX, positionY = "bottom", responsiveSwitch, fitToParent = false, invertPosition = false) => {
  const positionStyle = ref("");
  const widthStyle = ref("width: fit-content;");
  const calculatePosition = () => {
    if (fitToParent) {
      widthStyle.value = `width: ${anchorElement.value?.clientWidth}px;`;
    } else {
      widthStyle.value = "width: fit-content;";
    }
    positionStyle.value = `top: ${calculatePositionY()}px; ${calculatePositionX()}`;
  };
  watch(
    () => isOpen.value,
    async (value) => {
      if (import.meta.server) {
        return;
      }
      if (value) {
        requestAnimationFrame(calculatePosition);
        const scrollableElements = findScrollableElements();
        scrollableElements.forEach((element) => {
          element.addEventListener(
            "scroll",
            () => {
              requestAnimationFrame(calculatePosition);
            },
            false
          );
          window.addEventListener("scroll", () => {
            requestAnimationFrame(calculatePosition);
          });
        });
        window.addEventListener("resize", () => {
          calculatePosition();
        });
      } else {
        const scrollableElements = findScrollableElements();
        scrollableElements.forEach((element) => {
          element.removeEventListener("scroll", () => {
            requestAnimationFrame(calculatePosition);
          });
        });
        document.removeEventListener("resize", () => {
          calculatePosition();
        });
      }
    },
    { immediate: true }
  );
  const calculatePositionX = () => {
    const dropdown = dropdownElement.value;
    const anchor = anchorElement.value;
    const viewPortWidth = window.innerWidth;
    let position = "";
    if (anchor && dropdown) {
      const anchorLeftPosition = anchor.getBoundingClientRect().left;
      const anchorRightPosition = viewPortWidth - anchor.getBoundingClientRect().right;
      const shouldPositionLeft = positionX === "left" && !invertPosition || positionX === "right" && invertPosition;
      const isOverflowingLeft = shouldPositionLeft ? anchorLeftPosition - dropdown.clientWidth < 0 : viewPortWidth - (anchorRightPosition + dropdown.clientWidth) < 0;
      const isOverflowingRight = shouldPositionLeft ? anchorLeftPosition + dropdown.clientWidth > viewPortWidth : anchorRightPosition < 0;
      if (isOverflowingLeft) {
        position = "left: 0px";
      } else if (isOverflowingRight) {
        position = "right: 0px";
      } else {
        position = shouldPositionLeft ? `left: ${anchorLeftPosition}px;` : `right: ${anchorRightPosition}px;`;
      }
    }
    return position;
  };
  const calculatePositionY = () => {
    const gapBetweenButtonAndDropdown = 4;
    const paddingY = 8;
    const viewportHeight = window.innerHeight;
    if (!anchorElement.value || !dropdownElement.value) {
      return -1e3;
    }
    const buttonRect = anchorElement.value.getBoundingClientRect();
    const dropdownHeight = dropdownElement.value.getBoundingClientRect().height || 0;
    const topPosition = buttonRect.top - dropdownHeight - gapBetweenButtonAndDropdown;
    const bottomPosition = buttonRect.bottom + gapBetweenButtonAndDropdown;
    const hasSpaceAtTop = topPosition >= 0;
    const hasSpaceAtBottom = bottomPosition + dropdownHeight <= viewportHeight;
    const fallbackPosition = positionY === "bottom" ? Math.max(0, viewportHeight - dropdownHeight - paddingY) : paddingY;
    let result = 0;
    if (positionY === "bottom") {
      if (hasSpaceAtBottom) {
        result = bottomPosition;
      } else if (hasSpaceAtTop) {
        result = topPosition;
      } else {
        result = fallbackPosition;
      }
    } else {
      if (hasSpaceAtTop) {
        result = topPosition;
      } else if (hasSpaceAtBottom) {
        result = bottomPosition;
      } else {
        result = fallbackPosition;
      }
    }
    if (responsiveSwitch) {
      if (result + dropdownHeight > viewportHeight) {
        result = Math.max(0, viewportHeight - dropdownHeight - paddingY);
      }
      if (result < 0) {
        result = paddingY;
      }
    }
    return result;
  };
  return {
    widthStyle,
    positionStyle,
    calculatePosition
  };
};
